<template>
  <ArticleCategory is-edit />
</template>

<script>
import ArticleCategory from '@/layouts/components/form/ArticleCategory.vue'

export default {
  components: { ArticleCategory },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
